export default __webpack_public_path__ + "static/media/add-icon.819c4adc.svg";